import { isArr, isValid } from '@formily/shared'
import { useField } from '@formily/vue'
import { observer } from '@formily/reactive-vue'
import { h, defineComponent } from 'vue-demi'
import './style.scss'

const SelectPreview = observer(
  defineComponent({
    name: 'SelectPreviewText',
    props: [],
    setup(_props, { attrs }) {
      const fieldRef = useField()
      const field = fieldRef.value
      const props = attrs
      const dataSource =
        field && field.dataSource && field.dataSource.length
          ? field.dataSource
          : props && props.options && props.options.length
          ? props.options
          : []
      const getSelected = () => {
        const value = props.value
        if (props.multiple) {
          return isArr(value) ? value.map(val => ({ label: val, value: val })) : []
        } else {
          return isValid(value) ? [{ label: value, value }] : []
        }
      }

      const getLabels = () => {
        const selected = getSelected()
        if (!selected.length) {
          return 'N/A'
        }
        if (field?.address?.entire === 'visitDineIn' && props.value === 0) {
          return 'N/A'
        }
        return selected
          .map(({ value, label }, key) => {
            const dataSourceItem = dataSource && dataSource.find(item => item.value === value)
            const text = (dataSourceItem && dataSourceItem.label) || label
            return text
          })
          .join(',')
      }

      return () => {
        return h(
          'div',
          {
            class: ['input-readPretty'],
            style: attrs.style,
          },
          [getLabels()],
        )
      }
    },
  }),
)

export default SelectPreview
